import { Tag, Icon, IconName } from '@unmind/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Lightning, Sparkles } from 'icons';
import { practitionerFragment as TPractitioner } from 'Services/BeGateway/Practitioner/__generated__/practitionerFragment';

import { Wrapper } from './styles';

export default ({ practitioner }: { practitioner?: TPractitioner }) => {
  const { t } = useTranslation('book', { keyPrefix: 'practitioner.pill' });
  const theme = useTheme();
  const { photoUrls, availability, isMatch } = practitioner || {};
  const avatar = photoUrls?.[0]?.url;

  return (
    <Wrapper className={`practitioner-avatar ${isMatch ? 'match' : ''}`}>
      {isMatch && (
        <Tag
          label={t('topMatch')}
          LeftIcon={Sparkles}
          className="tag top-match"
        />
      )}

      <span className="img-wrapper">
        {!!avatar ? (
          <img src={avatar} alt="" />
        ) : (
          <Icon
            iconName={IconName.Person}
            colors={{
              primary: theme.colors.book.practitioners.avatar.fallback,
            }}
          />
        )}
      </span>

      {!!availability?.hasAvailability && (
        <Tag
          label={t('instantBook')}
          LeftIcon={Lightning}
          className="tag instant-book"
        />
      )}
    </Wrapper>
  );
};
